import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { Row, Col } from "react-bootstrap";

import React from "react";

const RulesScreenOrCondition = (props) => {
  const { orNameCondition } = props;
  return (
    <Card className="bg-EFEFEF cardFullScreen">
      {" "}
      <Card.Header>Grouping Conditions</Card.Header>
      <Card.Body>
        <Row>
          <Col >
            <h4>
              {orNameCondition &&
                orNameCondition.split(/[<>]/).map((badge, i) => {
                  return (
                    <>
                      {badge.trim() === "(" || badge.trim() === ")" ? (
                        <span className="vertical-divider" />
                      ) : (
                        <>
                          <Badge
                            key={i}
                            pill
                            bg="light"
                            className={
                              orNameCondition.split(/[<>]/)[i] === " Or " ||
                              orNameCondition.split(/[<>]/)[i - 1] === " Or " ||
                              orNameCondition.split(/[<>]/)[i + 1] === " Or "
                                ? "yellowbadge"
                                : "bluebadge"
                            }
                          >
                            {badge.trim().length > 0 && badge}
                          </Badge>{" "}
                        </>
                      )}
                    </>
                  );
                })}
            </h4>{" "}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default RulesScreenOrCondition;
